import {
  FormHelperText,
  IconButton,
  TextField,
  Typography
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  TableRowHead,
  UploadButton,
  useStyles
} from "components/request-document/components/Commons";
import CompanyInfoSection from "components/request-document/components/CompanyInfoSection";
import ContractTermSection from "components/request-document/components/ContractTermSection";
import { useExtendsionFormPartC } from "components/smart-visa-extension/useExtendsionForm";
import { EXTENSION_DOCUMENT_STEP } from "libs/configs/constant";
import { openFileById } from "libs/utils/file";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React from "react";
import { useSelector } from "react-redux";
import { selectMasterData } from "redux/modules/masterSlice";
import FileService from "services/FileService";

export default function PartC() {
  const classes = useStyles();
  const { formik, onSaveDraft } = useExtendsionFormPartC();

  const masterData = useSelector(selectMasterData);
  const technologyCoreConfig = get(masterData, "technologyCoreConfig", []);
  const applicantConfig = get(masterData, "applicantConfig", []);
  const technologyEmploymentConfig = get(
    masterData,
    "technologyEmploymentConfig",
    []
  );

  return (
    <div className={classes.root}>
      <ContentTitle
        title="APPLICATION FOR SMART VISA EXTENSION"
        subTitle="SMART VISA EXTENSION"
      />
      <Steper isExtend currentStep={0} stepInfo={EXTENSION_DOCUMENT_STEP} />
      <form onSubmit={formik.handleSubmit}>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={3}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part C: Company information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <CompanyInfoSection formik={formik} colSpan={3} />

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={6} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Business or products or services description
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="ProductService"
                        value={formik.values.ProductService}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ProductService", formik)}
                        helperText={getErrorMessage("ProductService", formik)}
                        multiline
                        disabled
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={7} />
                    <div className={classes.wrapField}>
                      <InputLabel>Major products or services</InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Sale revenue (Approximate in Baht)
                      </InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="MajorService"
                    value={formik.values.MajorService}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("MajorService", formik)}
                    helperText={getErrorMessage("MajorService", formik)}
                    multiline
                    rows={5}
                    rowsMin={5}
                    rowsMax={5}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="SaleRevenune"
                    value={formik.values.SaleRevenune}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("SaleRevenune", formik)}
                    helperText={getErrorMessage("SaleRevenune", formik)}
                    multiline
                    rows={5}
                    rowsMin={5}
                    rowsMax={5}
                  />
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={8} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Manufacturing/Service Process. Please provide a process
                        diagram that explains the manufacturing/service process
                        (additional documents can be attached).
                      </InputLabel>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRowHead>
                <StyledTableCell colSpan={2} align="center">
                  <InputLabel>Process Diagram</InputLabel>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <InputLabel>Explanation</InputLabel>
                </StyledTableCell>
              </TableRowHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.flexRow}>
                    <InputLabel>File Upload ( PDF, JPG )</InputLabel>
                    <div style={{ width: 18 }} />
                    <UploadButton
                      title={
                        get(formik.values, `ProcessDiagram.FileID`, "")
                          ? "Edit"
                          : "+ Add"
                      }
                      id={`upload-ProcessDiagram`}
                      onChange={async (event) => {
                        try {
                          const response = await FileService.uploadFile({
                            file: event.target.files[0],
                            Status: true,
                          });
                          const fileId = response.results?.fileID;
                          const [filename, ext] =
                            event.target.files[0].name.split(".");

                          formik.setFieldValue(`ProcessDiagram`, {
                            processfileID: fileId,
                            FileID: fileId,
                            filename,
                            ext,
                            Status: true,
                          });
                        } catch (error) {
                          console.log("Upload error", error);
                        }
                      }}
                    />
                    {get(formik.values, `ProcessDiagram.FileID`, "") && (
                      <IconButton
                        style={{ width: 40 }}
                        size="small"
                        onClick={async () => {
                          const processfileID = get(
                            formik.values,
                            `ProcessDiagram.FileID`,
                            ""
                          );
                          openFileById(processfileID);
                        }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                    )}
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <TextField
                    variant="outlined"
                    className={classes.textField}
                    name="Explanation"
                    value={formik.values.Explanation}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={isError("Explanation", formik)}
                    helperText={getErrorMessage("Explanation", formik)}
                    multiline
                    rows={10}
                  />
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={9} />
                    <div className={classes.wrapField}>
                      <InputLabel>Acquisition of core technology</InputLabel>
                      <FormGroup row>
                        {technologyCoreConfig.map((technologyCore) => (
                          <FormControlLabel
                            key={technologyCore.technologyCoreID}
                            control={
                              <StyleCheckbox
                                name={technologyCore.technologyCoreName}
                                value={technologyCore.technologyCoreID}
                                checked={
                                  formik.values.technologyCore ===
                                  technologyCore.technologyCoreID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "technologyCore",
                                    technologyCore.technologyCoreID
                                  );
                                }}
                              />
                            }
                            label={technologyCore.technologyCoreName}
                          />
                        ))}
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Please explain</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="technologyCoreExplain"
                        value={formik.values.technologyCoreExplain}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("technologyCoreExplain", formik)}
                        helperText={getErrorMessage(
                          "technologyCoreExplain",
                          formik
                        )}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={10} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Objective of technology employment
                      </InputLabel>
                      <FormGroup row>
                        {technologyEmploymentConfig.map(
                          (technologyEmployment) => (
                            <FormControlLabel
                              key={technologyEmployment.technologyEmploymentID}
                              control={
                                <StyleCheckbox
                                  name={
                                    technologyEmployment.technologyEmploymentName
                                  }
                                  value={
                                    technologyEmployment.technologyEmploymentID
                                  }
                                  checked={
                                    formik.values.technologyEmployment ===
                                    technologyEmployment.technologyEmploymentID
                                  }
                                  onClick={() => {
                                    formik.setFieldValue(
                                      "technologyEmployment",
                                      technologyEmployment.technologyEmploymentID
                                    );
                                  }}
                                />
                              }
                              label={
                                technologyEmployment.technologyEmploymentName
                              }
                            />
                          )
                        )}
                      </FormGroup>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>Please explain</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="technologyEmploymentExplain"
                        value={formik.values.technologyEmploymentExplain}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("technologyEmploymentExplain", formik)}
                        helperText={getErrorMessage(
                          "technologyEmploymentExplain",
                          formik
                        )}
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={11} />
                    <div className={classes.wrapField}>
                      <Typography variant="h6" className={classes.title}>
                        Contract term
                      </Typography>
                      <ContractTermSection isSmartForm formik={formik} />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={12} />
                    <div className={classes.wrapField}>
                      <Typography variant="h6" className={classes.title}>
                        Average income per month* (Baht)
                      </Typography>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="AverageIncomeBaht"
                        type="number"
                        value={formik.values.AverageIncomeBaht}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("AverageIncomeBaht", formik)}
                        helperText={getErrorMessage(
                          "AverageIncomeBaht",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel style={{ marginTop: 16 }}>
                        Salary (Baht per month)
                      </InputLabel>
                      <TextField
                        className={classes.textField}
                        variant="outlined"
                        name="SalaryBaht"
                        type="number"
                        value={formik.values.SalaryBaht}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("SalaryBaht", formik)}
                        helperText={getErrorMessage("SalaryBaht", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={0} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Other items of income (Please specify)
                      </InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="OrtherIncome"
                        value={formik.values.OrtherIncome}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("OrtherIncome", formik)}
                        helperText={getErrorMessage("OrtherIncome", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <Bagde number={13} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        The applicant’s involvement in the company
                      </InputLabel>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("applicant", formik)}
                        style={{ width: 550 }}
                      >
                        <InputLabel>
                          Select the applicant’s involvement in the company
                        </InputLabel>
                        <Select
                          label="Select the applicant’s involvement in the company"
                          name="applicants"
                          value={formik.values.applicants}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {applicantConfig.map((applicant) => (
                            <MenuItem
                              value={applicant.applicantID}
                              key={applicant.applicantID}
                            >
                              {applicant.applicantName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText error={isError("applicant", formik)}>
                          {getErrorMessage("applicant", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel>Specify</InputLabel>
                      <TextField
                        variant="outlined"
                        className={classes.textField}
                        name="specift"
                        value={formik.values.specift}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("specift", formik)}
                        helperText={getErrorMessage("specift", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <div />
            </TableBody>
          </Table>
        </TableContainer>

        <ButtonController
          isExtend
          onClickSaveDraft={() => {
            onSaveDraft();
          }}
        />
      </form>
    </div>
  );
}
